const formatDate = (localDateTimeStr: string) => {
  const match = localDateTimeStr.match(
    /(\d{4})-(\d{2})-(\d{2})[\sT](\d{2}):(\d{2}):(\d{2})(.(\d+))?/,
  );
  if (!match) throw new Error('Invalid format.');

  const [, year, month, date] = match;

  const paddedMonth = month.padStart(2, '0');
  const paddedDate = date.padStart(2, '0');

  return `${paddedDate}/${paddedMonth}/${year}`;
};

export { formatDate };
